/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isNil, get, includes } from 'lodash';
import { Container } from 'react-bootstrap';
import { Meteor } from 'meteor/meteor';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Accounts } from 'meteor/accounts-base';
import { Switch, Route } from 'react-router-dom';
import { Roles } from 'meteor/alanning:roles';
import { Bert } from 'meteor/themeteorchef:bert';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import Navigation from '../../../ui/components/Navigation';

import Public from '../../../ui/components/Public';
import Authenticated from '../../../ui/components/Authenticated';
import Authorized from '../../../ui/components/Authorized';
import EmailNotVerified from '../../../ui/components/EmailNotVerified';

import Home from '../../../ui/pages/Home';

import Profile from '../../../ui/pages/Profile';
import SignUp from '../../../ui/pages/SignUp';
import Login from '../../../ui/pages/Login';
import Logout from '../../../ui/pages/Logout';

import RecoverPassword from '../../../ui/pages/RecoverPassword';
import ResetPassword from '../../../ui/pages/ResetPassword';
import VerifyEmail from '../../../ui/pages/VerifyEmail';

import AdminUsers from '../../../ui/pages/AdminUsers';
import AdminUser from '../../../ui/pages/AdminUser';
import AdminUserSettings from '../../../ui/pages/AdminUserSettings';

import UserManagement from '../../../ui/pages/UserManagement';
import NewUser from '../../../ui/pages/NewUser';
import EditUser from '../../../ui/pages/EditUser';

import Terms from '../../../ui/pages/Terms';
import Privacy from '../../../ui/pages/Privacy';
import ExamplePage from '../../../ui/pages/ExamplePage';

import TableListContainer from '../../../ui/containers/TableListContainer';

import Layers from '../../../ui/pages/Layers';
import NewLayer from '../../../ui/pages/NewLayer';
import EditLayer from '../../../ui/pages/EditLayer';
import ViewLayer from '../../../ui/pages/ViewLayer';

import Atlas from '../../../ui/pages/Atlas';
import AtlasList from '../../../ui/pages/AtlasList';
import NewAtlas from '../../../ui/pages/NewAtlas';
import EditAtlas from '../../../ui/pages/EditAtlas';
import ViewAtlas from '../../../ui/pages/ViewAtlas';
import PublicAtlas from '../../../ui/pages/PublicAtlas';

import Maps from '../../../ui/pages/Maps';
import ViewMap from '../../../ui/pages/ViewMap';
import NewMap from '../../../ui/pages/NewMap';
import EditMap from '../../../ui/pages/EditMap';
import PublicMap from '../../../ui/pages/PublicMap';

import Sources from '../../../ui/pages/Sources';
import ViewSource from '../../../ui/pages/ViewSource';
import NewSource from '../../../ui/pages/NewSource';

import NewDBLayerServer from '../../../ui/pages/NewDBLayerServer';
import NewDBFeatureServer from '../../../ui/pages/NewDBFeatureServer';
import NewDBOGCAPI from '../../../ui/pages/NewDBOGCAPI';
import NewDBExternal from '../../../ui/pages/NewDBExternal';
import FeaturesFuctions from '../../../ui/pages/FeaturesFuctions';

import MapServerElements from '../../../ui/pages/MapServerElements';
import ViewMapServerElement from '../../../ui/pages/ViewMapServerElement';
import NewMapServerElement from '../../../ui/pages/NewMapServerElement';
import EditMapServerElement from '../../../ui/pages/EditMapServerElement';
import NewLayerFromMapServerElement from '../../../ui/pages/NewLayerFromMapServerElement';

import Connectors from '../../../ui/pages/Connectors';
import ViewConnector from '../../../ui/pages/ViewConnector';
import NewConnector from '../../../ui/pages/NewConnector';
import EditConnector from '../../../ui/pages/EditConnector';

import VideosProfiles from '../../../ui/pages/VideosProfiles';
import NewVideosProfiles from '../../../ui/pages/NewVideosProfiles';
import ViewVideosProfiles from '../../../ui/pages/ViewVideosProfiles';

import Tasker from '../../../ui/pages/Tasker';
import SavedTasksContainer from '../../../ui/containers/SavedTasksContainer';
import TaskMonitorContainer from '../../../ui/containers/TaskMonitorContainer';

import PublicGraphic from '../../../ui/pages/PublicGraphic';
import PublicThematicTable from '../../../ui/pages/PublicThematicTable';

import NotFound from '../../../ui/pages/NotFound';
import GDPRConsentModal from '../../../ui/components/GDPRConsentModal';

import { getUserName, getEmailAddress, isEmailVerified } from '../../../api/Users/user-operations';
import UserControl from '../../../api/UserControl/UserControl';
import methodPromise from '../../../modules/method-promise-wrapper';

import { onLogin, onLogout } from '../../../modules/redux/actions';
import withTrackerSsr from '../../../modules/with-tracker-ssr';
import NewLayerFromServer from '../../../ui/pages/NewLayerFromServer';
import AdvancedMap from '../../../ui/pages/AdvancedMap';
import LoadingIpsilumFree from '../../../ui/components/LoadingIpsilumFree';
import { DEFAULT_DEPLOY_CONFIG } from '../../../api/UserSettings/UserSettings';

library.add(fas, far, fab);

const { isTierra2, isAdvanced, deployID } = Meteor.settings.public;

class App extends Component {
  state = {
    deployEnv: '',
    ready: false,
    afterLoginPath: null,
    deployConfig: {}
  };

  componentDidMount() {
    this.getDeployEnv();
    this.getDeployConfig();
    const { handleOnLogin, handleOnLogout } = this.props;
    Accounts.onLogin(() => handleOnLogin());
    Accounts.onLogout(() => handleOnLogout());
    this.setPageReady();
    this.sendInfoUserToBack();
  }

  getDeployEnv = async () => {
    try {
      const deployEnv = await methodPromise('app.getDevEnvironment');
      this.setState({ deployEnv });
    } catch (error) {
      Bert.alert('Could Not Get Dev Environment', 'danger');
    }
  };

  getDeployConfig = async () => {
    let DEPLOY_CONFIG_API = '';
    try {
      const APISettings = await methodPromise('admin.fetchAPISetting');
      if (APISettings.length > 0) {
        DEPLOY_CONFIG_API = APISettings[0].deployConfigAPI;
      }
    } catch (error) {
      // handleMethodException(error);
    }
    try {
      const response = await fetch(DEPLOY_CONFIG_API, {
        method: 'POST',
        body: JSON.stringify({ user: deployID }),
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      const data = await response.json();
      this.setState({ deployConfig: data.Maps });
    } catch (error) {
      this.setState({ deployConfig: DEFAULT_DEPLOY_CONFIG.Maps });
    }
  };

  sendInfoUserToBack = async () => {
    const { roles, userId } = this.props;
    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
    const coordinates = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude
    };
    const infoUser = {
      currentLocation: coordinates,
      userId,
      userRole: roles,
      time:
        `${new Date().getDate()}-${new Date().getMonth() + 1}-${new Date().getFullYear()} ` +
        `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
    };

    fetch('https://sd1.ipsgeoprocesing.ipsilum.com/MG/geolocation/tracking', {
      method: 'POST',
      body: JSON.stringify({
        user: infoUser,
        dataBase: ''
      }),
      headers: { 'Content-Type': 'application/json' }
    });
  };

  setPageReady = () => {
    this.setState({ ready: true });
  };

  setAfterLoginPath = afterLoginPath => {
    this.setState({ afterLoginPath });
  };

  render() {
    const { props, state, setAfterLoginPath } = this;
    const { history, match, location, userControlSetting, ...propsNoRouter } = props;
    const isFullScreen = includes(get(location, 'pathname'), 'shared');
    const propsToPass = { ...propsNoRouter, ...state, isFullScreen, userControlSetting };
    const isAppReady = state.ready && !props.loading && state.deployEnv !== '';

    return (
      <div className={isAppReady ? 'visible' : 'invisible'}>
        {props.authenticated && (
          <GDPRConsentModal userId={props.userId} userControlSetting={userControlSetting} />
        )}
        <Navigation {...propsToPass} />
        <Container fluid>
          <Switch>
            <Route
              exact
              name="home"
              path="/"
              render={routeProps => <Home {...routeProps} {...propsToPass} />}
            />
            {isTierra2 && (
              <Route
                exact
                path="/atlas"
                render={routeProps => (
                  <Atlas
                    setAfterLoginPath={setAfterLoginPath}
                    {...props}
                    {...state}
                    {...routeProps}
                  />
                )}
              />
            )}
            {!isTierra2 && (
              <Authenticated
                exact
                path="/atlas"
                setAfterLoginPath={setAfterLoginPath}
                component={TableListContainer}
                Page={AtlasList}
                {...propsToPass}
              />
            )}
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/atlas/new"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={NewAtlas}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/atlas/:atlas_id/edit"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={EditAtlas}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/atlas/:atlas_id"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={ViewAtlas}
              {...propsToPass}
            />

            <Authenticated
              exact
              path="/taskmonitor"
              setAfterLoginPath={setAfterLoginPath}
              component={TaskMonitorContainer}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/upgrade"
              setAfterLoginPath={setAfterLoginPath}
              component={LoadingIpsilumFree}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/savedtasks"
              setAfterLoginPath={setAfterLoginPath}
              component={TableListContainer}
              Page={SavedTasksContainer}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/maps"
              setAfterLoginPath={setAfterLoginPath}
              component={TableListContainer}
              Page={Maps}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/maps/new"
              component={NewMap}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/maps/:map_id/edit"
              component={EditMap}
              {...propsToPass}
              setAfterLoginPath={setAfterLoginPath}
            />
            {isAdvanced && (
              <Authenticated
                exact
                path="/maps/:map_id/AdvancedMap/:variable?"
                component={AdvancedMap}
                {...propsToPass}
                setAfterLoginPath={setAfterLoginPath}
              />
            )}
            <Authenticated
              exact
              path="/maps/:map_id"
              component={ViewMap}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/layers"
              setAfterLoginPath={setAfterLoginPath}
              component={TableListContainer}
              Page={Layers}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/layers/new"
              component={NewLayer}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/layers/newLoad"
              component={NewLayerFromServer}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/layers/:layer_id/edit"
              component={EditLayer}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authenticated
              path="/layers/:layer_id"
              component={ViewLayer}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/sources"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={TableListContainer}
              Page={Sources}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/sources/new"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={NewSource}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/sources/:source_id/edit"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              isEditorMode
              component={NewSource}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/sources/:source_id"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={ViewSource}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/layerServers"
              pathAfterFailure="/"
              component={TableListContainer}
              Page={MapServerElements}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />

            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/DBLayerServers"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={NewDBLayerServer}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/DBFeatureServers"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={NewDBFeatureServer}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/OGC-API-Features"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={NewDBOGCAPI}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/DBExternal"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={NewDBExternal}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/Functions"
              setAfterLoginPath={setAfterLoginPath}
              component={FeaturesFuctions}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/layerServers/new"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={NewMapServerElement}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/layerServers/:mapServerElement_id/edit"
              pathAfterFailure="/"
              component={EditMapServerElement}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/layerServers/:mapServerElement_id/newLayer"
              pathAfterFailure="/"
              component={NewLayerFromMapServerElement}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/layerServers/:mapServerElement_id"
              pathAfterFailure="/"
              component={ViewMapServerElement}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/connections"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={TableListContainer}
              Page={Connectors}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/connections/new"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={NewConnector}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/connections/:connector_id/edit"
              pathAfterFailure="/"
              component={EditConnector}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/connections/:connector_id"
              pathAfterFailure="/"
              component={ViewConnector}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/videos/profiles"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={TableListContainer}
              Page={VideosProfiles}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/videos/profiles/new"
              pathAfterFailure="/"
              setAfterLoginPath={setAfterLoginPath}
              component={NewVideosProfiles}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['basic-user', 'premium-user', 'admin']}
              path="/videos/profiles/:profile_id"
              pathAfterFailure="/"
              component={ViewVideosProfiles}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/itasker"
              setAfterLoginPath={setAfterLoginPath}
              component={Tasker}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/sharedPrivate/maps/:public_map_id/:variable?"
              privateShared
              setAfterLoginPath={setAfterLoginPath}
              component={PublicMap}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/sharedPrivateUser/maps/:public_map_id/:variable?"
              sharedPrivateUser
              setAfterLoginPath={setAfterLoginPath}
              component={PublicMap}
              sharedUser
              openModalUserPrivate
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/sharedPrivate/data/:public_layer_data_id"
              privateShared
              setAfterLoginPath={setAfterLoginPath}
              component={PublicThematicTable}
              {...propsToPass}
            />
            <Authenticated
              exact
              path="/sharedPrivate/graphics/:public_graphic_id"
              privateShared
              setAfterLoginPath={setAfterLoginPath}
              component={PublicGraphic}
              {...propsToPass}
            />
            <Authenticated
              component={PublicAtlas}
              exact
              path="/sharedPrivate/atlas/:public_atlas_id"
              privateShared
              setAfterLoginPath={setAfterLoginPath}
              sharedUser={false}
              {...propsToPass}
            />
            <EmailNotVerified
              exact
              path="/profile"
              component={Profile}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Public path="/signup" component={SignUp} {...propsToPass} />
            <Public path="/login" component={Login} {...propsToPass} />
            <Route
              path="/shared/maps/:public_map_id/:variable?"
              render={routeProps => (
                <PublicMap
                  {...propsToPass}
                  {...routeProps}
                  sharedUser={false}
                  privateShared={false}
                  sharedPrivateUser={false}
                  shareAnnotation={false}
                  setAfterLoginPath={setAfterLoginPath}
                />
              )}
            />
            <Route
              path="/sharedLocation/maps/:public_map_id/:formats/:annotationId/:variable?"
              render={routeProps => (
                <PublicMap
                  {...propsToPass}
                  {...routeProps}
                  shareAnnotation
                  sharedUser={false}
                  privateShared={false}
                  sharedPrivateUser={false}
                  setAfterLoginPath={setAfterLoginPath}
                />
              )}
            />
            <Route
              path="/sharedUser/maps/:public_map_id/:variable?"
              render={routeProps => (
                <PublicMap
                  {...propsToPass}
                  {...routeProps}
                  sharedUser
                  openModalUserPrivate
                  privateShared={false}
                  shareAnnotation={false}
                  sharedPrivateUser={false}
                  setAfterLoginPath={setAfterLoginPath}
                />
              )}
            />
            <Route
              path="/sharedUser/atlas/:public_atlas_id"
              render={routeProps => (
                <PublicAtlas
                  {...propsToPass}
                  {...routeProps}
                  setAfterLoginPath={setAfterLoginPath}
                  openModalUserPrivate
                  sharedUser
                  privateShared={false}
                />
              )}
            />
            <Route
              path="/shared/graphics/:public_graphic_id"
              render={routeProps => (
                <PublicGraphic
                  {...propsToPass}
                  {...routeProps}
                  setAfterLoginPath={setAfterLoginPath}
                />
              )}
            />
            <Route
              path="/shared/data/:public_layer_data_id"
              render={routeProps => (
                <PublicThematicTable
                  {...propsToPass}
                  {...routeProps}
                  setAfterLoginPath={setAfterLoginPath}
                />
              )}
            />
            <Route
              path="/shared/atlas/:public_atlas_id"
              render={routeProps => (
                <PublicAtlas
                  {...propsToPass}
                  {...routeProps}
                  setAfterLoginPath={setAfterLoginPath}
                  sharedUser={false}
                  privateShared={false}
                />
              )}
            />
            <Route
              path="/logout"
              render={routeProps => (
                <Logout {...routeProps} {...propsToPass} setAfterLoginPath={setAfterLoginPath} />
              )}
            />
            <Route
              path="/verify-email/:token"
              render={routeProps => <VerifyEmail {...routeProps} {...propsToPass} />}
            />
            <Route name="recover-password" path="/recover-password" component={RecoverPassword} />
            <Route
              path="/reset-password/:token"
              render={routeProps => <ResetPassword {...routeProps} {...propsToPass} />}
            />

            <Route name="terms" path="/terms" component={Terms} />
            <Route name="privacy" path="/privacy" component={Privacy} />
            <Route name="examplePage" path="/example-page" component={ExamplePage} />
            <Authorized
              exact
              allowedRoles={['free-user', 'admin']}
              path="/users"
              pathAfterFailure="/"
              component={UserManagement}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['admin']}
              path="/users/new"
              pathAfterFailure="/"
              component={NewUser}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['admin']}
              path="/users/:user_id/edit"
              pathAfterFailure="/"
              component={EditUser}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['admin']}
              path="/admin/users"
              pathAfterFailure="/"
              component={AdminUsers}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['admin']}
              path="/admin/users/settings"
              pathAfterFailure="/"
              component={AdminUserSettings}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Authorized
              exact
              allowedRoles={['admin']}
              path="/admin/users/:_id"
              pathAfterFailure="/"
              component={AdminUser}
              setAfterLoginPath={setAfterLoginPath}
              {...propsToPass}
            />
            <Route component={NotFound} />
          </Switch>
        </Container>
      </div>
    );
  }
}

App.defaultProps = {
  emailAddress: '',
  history: {},
  location: {},
  match: {},
  roles: [],
  userControlSetting: {},
  userId: ''
};

App.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  emailAddress: PropTypes.string,
  emailVerified: PropTypes.bool.isRequired,
  handleOnLogin: PropTypes.func.isRequired,
  handleOnLogout: PropTypes.func.isRequired,
  history: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.object,
  match: PropTypes.object,
  roles: PropTypes.array,
  userControlSetting: PropTypes.object,
  userId: PropTypes.string
};

const mapStateToProps = state => ({ ...state });
const mapDispatchToProps = dispatch => ({
  handleOnLogin: data => dispatch(onLogin(data)),
  handleOnLogout: data => dispatch(onLogout(data))
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTrackerSsr(() => {
    const app = Meteor.subscribe('app');
    const loggingIn = Meteor.loggingIn();
    const userControlSub = Meteor.subscribe('UserControl');
    const userSettings = UserControl.find({}).fetch();
    const loading = !app.ready() && !Roles.subscription.ready() && !userControlSub.ready();

    const user = Meteor.user();
    const userId = Meteor.userId();
    if (isNil(user)) {
      return {
        loading,
        loggingIn,
        authenticated: !loggingIn && !!userId,
        name: '',
        roles: !loading ? Roles.getRolesForUser(userId) : [],
        isAdmin: Roles.userIsInRole(userId, 'admin'),
        isPremium: Roles.userIsInRole(userId, 'premium-user'),
        isBasic: Roles.userIsInRole(userId, 'basic-user'),
        isFree: Roles.userIsInRole(userId, 'free-user'),
        userId,
        emailAddress: '',
        emailVerified: false,
        userControlSetting: userSettings[0]
      };
    }
    const name = getUserName(user);
    const emailAddress = getEmailAddress(user);
    const emailVerified = isEmailVerified(user);
    return {
      loading,
      loggingIn,
      authenticated: !loggingIn && !!userId,
      name: name || emailAddress,
      roles: !loading ? Roles.getRolesForUser(userId) : [],
      isAdmin: Roles.userIsInRole(userId, 'admin'),
      isPremium: Roles.userIsInRole(userId, 'premium-user'),
      isBasic: Roles.userIsInRole(userId, 'basic-user'),
      isFree: Roles.userIsInRole(userId, 'free-user'),
      userId,
      emailAddress,
      emailVerified,
      userControlSetting: userSettings[0]
    };
  })
)(App);
